import InputMask from 'react-input-mask';
import  {useState} from "react";
import { Input } from 'reactstrap';

function Phone(props) {

    let [value,updateValue] = useState(props.value?props.value:'');
    let [error,updateError] = useState(props.error?props.error:'');
    let className = '';

    const handleChange = element => {
        updateValue(element.target.value);
        element.target.value = element.target.value.replace(/[^0-9]/g,'');
        props.onChange(element);
    };

    if(props.error){
        className="is-invalid";
    }
    
    return (
        <div>
            <Input
              type="text"
              mask={ value.length > 14 ? '(99) 99999-9999' : '(99) 9999-99999' }
              formatChars={{ 9: '[0-9]', '?': '[0-9 ]' }}
              maskChar={false}
              tag={InputMask}
              className={className}

              id={'id_'+props.name} 
              name={props.name} 
              onChange={handleChange}
              value={value}
              readOnly={props.readOnly}
              autoFocus={props.autoFocus?true:false}
            />
            {props.error && (
                <span id="terms-error" className="error invalid-feedback" style={{display:'inline'}}>{props.error}</span>
            )}
        </div>
    );
}
export default Phone;
